import { MoreVertical } from "react-feather";

export function ListDragHandle() {
  return (
    <div
      className="absolute cursor-move drag-handle"
      style={{
        width: 16,
        height: 30,
        left: 0,
        borderRadius: 3,
        transform: "translateX(-20px)",
        color: "gray",
      }}
    >
      <MoreVertical className="absolute left-0" style={{ left: 2, top: 3, width: 18 }} />
      <MoreVertical className="absolute" style={{ left: -4, top: 3, width: 18 }} />
    </div>
  );
}
